import { Link } from "react-router-dom";
import { RainbowArcs } from "../motion/RainbowArcs";
import { NAV_LINKS } from "./Navbar";
import { LAWS } from "../../data/laws";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t hairline bg-ink text-parchment">
    <RainbowArcs
      animate={false}
      className="pointer-events-none absolute -bottom-10 right-[-6%] w-[60vw] max-w-[760px] text-terracotta/40"
    />
    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="eyebrow text-terracotta">שבע מצוות בני נח</p>
          <h2 className="mt-5 font-serif text-4xl leading-[1.05] tracking-tight sm:text-5xl">
            Seven laws.
            <br />
            <span className="italic text-parchment/70">One principle.</span>
          </h2>
          <p className="mt-5 font-serif text-xl italic text-terracotta">
            Loyalty — to oneself, to G-d, and to the world.
          </p>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-parchment/60">
            A warm, clear guide to what the Torah asks of every person — and how to
            live it, one ordinary day at a time.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <p className="eyebrow text-parchment/50">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.id}`}
                  className="link-underline text-sm text-parchment/80 hover:text-parchment"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-parchment/50">The Seven</p>
          <ul className="mt-5 space-y-3">
            {LAWS.map((law) => (
              <li key={law.slug}>
                <Link
                  to={`/laws/${law.slug}`}
                  data-testid={`footer-law-link-${law.slug}`}
                  className="link-underline flex items-baseline gap-3 text-sm text-parchment/80 hover:text-parchment"
                >
                  <span className="font-mono text-[10px] text-terracotta">0{law.number}</span>
                  {law.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-20 flex flex-col gap-4 border-t border-parchment/10 pt-8 text-xs text-parchment/40 sm:flex-row sm:items-center sm:justify-between">
        <p>One Essence — an educational guide to the Seven Laws of Noah.</p>
        <p className="font-mono uppercase tracking-[0.2em]">
          Study with a qualified rabbi for personal guidance
        </p>
        <Link to="/card" data-testid="footer-link-card" className="link-underline text-parchment/40 hover:text-parchment">
          Business card (print)
        </Link>
      </div>
    </div>
  </footer>
);
